import type { DiscoveryResults } from '@/types/data';
import type { KatsuEntityCountsOrBooleans } from '@/types/entities';
import type { FtsQueryType } from '@/features/search/types';

export const NO_RESULTS_DASHES = '———';

export const EMPTY_KATSU_ENTITY_COUNTS: KatsuEntityCountsOrBooleans = {
  phenopacket: 0,
  individual: 0,
  biosample: 0,
  experiment: 0,
  experiment_result: 0,
};

export const EMPTY_DISCOVERY_RESULTS: DiscoveryResults = {
  // individuals
  individualCount: 0,
  individualMatches: undefined,
  // biosamples
  biosampleCount: 0,
  biosampleChartData: [],
  // experiments
  experimentCount: 0,
  experimentChartData: [],
};

export const NON_FILTER_QUERY_PARAM_PREFIX = '_';
export const ENTITY_QUERY_PARAM = '_e';
export const TABLE_PAGE_QUERY_PARAM = '_p';
export const TABLE_PAGE_SIZE_QUERY_PARAM = '_ps';
export const TEXT_QUERY_PARAM = '_q';
export const TEXT_QUERY_TYPE_PARAM = '_qt';

// Supported text query types in the UI at the moment:
export const VALID_TEXT_QUERY_TYPES: FtsQueryType[] = ['plain', 'trigram'];
export const DEFAULT_TEXT_QUERY_TYPE: FtsQueryType = 'plain';
